import * as React from "react";
import { Fragment } from "react";
import OrganizationPage from "../organization/OrganizationPage";

const AppWrapper = () => {
  return (
    <Fragment>
      <OrganizationPage />
    </Fragment>
  );
};

export default AppWrapper;
